import React, { useEffect, useRef } from 'react';

import RichText from '../../generic/RichText';
import { getPosition } from '../ImageContainer';
import { isOnServer } from '../../../utils';
import { mergeClassNames } from '../../../utils/mergeClassnames';
import styles from './index.module.scss';

export const TextContainerSize = {
  small: {
    minHeight: '100px',
  },
  medium: {
    minHeight: '200px',
  },
  large: {
    minHeight: '300px',
  },
};

export default function TextContainer({
  slides,
  activeSlideIndex,
  className = '',
  showHeading = true,
  sideBySide = false,
  size = TextContainerSize.large,
}) {
  return (
    <ul className={mergeClassNames(styles.textContainer, className)} style={size}>
      {slides.map((slide, index) => (
        <TextCard
          slide={slide}
          key={index}
          index={index}
          activeSlideIndex={activeSlideIndex}
          showHeading={showHeading}
          sideBySide={sideBySide}
          size={size}
        />
      ))}
    </ul>
  );
}

function TextCard({ slide, index, activeSlideIndex, showHeading, sideBySide, size }) {
  const ref = useRef(null);

  // YES - this is a little yanky when the copy is too long!
  // Best solution is to write shotrter copy.
  useEffect(() => {
    if (ref.current === null || isOnServer) {
      return;
    }
    // Lets remember this here:
    let el = ref.current;

    // Fix things to animate them:
    const startHandler = event => {
      if (event.propertyName === 'opacity') {
        el.style.height = size.minHeight; // coresponds to min-height in the css
        el.style.position = 'absolute';
      }
    };

    const endHandler = event => {
      if (event.propertyName === 'opacity') {
        let style = window.getComputedStyle(el);
        let opacity = parseFloat(style.getPropertyValue('opacity'));
        if (opacity === 0) {
          // Hide things when they are hidden:
          el.style.height = 0;
        } else {
          // Release things to let the text flow:
          el.style.position = 'relative';
          el.style.height = 'auto';
        }
      }
    };
    el.addEventListener('transitionstart', startHandler);
    el.addEventListener('transitionend', endHandler);
    return () => {
      el.removeEventListener('transitionstart', startHandler);
      el.removeEventListener('transitionend', endHandler);
    };
  }, [index, size]);

  return (
    <li
      ref={ref}
      key={index}
      className={mergeClassNames(styles.textCard, styles[getPosition(index, activeSlideIndex)])}
    >
      <div className={mergeClassNames(styles.textCardInner, sideBySide ? styles.sideBySide : '')}>
        {showHeading && <h4 className={styles.heading}>{slide.heading || slide.title}</h4>}
        <RichText className={styles.body}>{slide.body || slide.description}</RichText>
      </div>
    </li>
  );
}
